import { initial_state } from './constants';
import mutations from './mutations';

export default {
  namespaced: true,
  state: { ...initial_state },
  mutations
}